import { createContext, useContext } from 'react';

export const CreativesContext = createContext([]);

export const useCreativesContext = () => useContext(CreativesContext);
